import React from "react"
import Navbar from './Components/Navbar'
import Home from "./Pages/Home"
import Gallery from "./Pages/Gallery"
import Videos from "./Pages/Videos"
import Contact from "./Pages/Contact"
import School8 from "./Pages/School8"
import School1 from "./Pages/School1"
import School9 from "./Pages/School9"
import Remember from "./Pages/Remember"
import We from "./Pages/We"
import Poselok from "./Pages/Poselok"
import Parents from "./Pages/Parents"
import { Route, Routes } from "react-router-dom";
import Meetings from "./Pages/Meetings"
import Kids from "./Pages/Kids"
import Geology from "./Pages/Geology"
import Kayrakkum from "./Pages/Kayrakkum"
import Kayrakkumer from "./Pages/Kayrakkumer"
import Thanks from "./Pages/Thanks"
import CookieConsent from "react-cookie-consent"


function App() {
 
  return (
    <>
    <div>
      <Navbar />
      <CookieConsent 
        debug={false}
        location="bottom"
        style={{ background: 'rgb(108 148 209)', textAlign: 'center', fontSize: '14px' }}
        buttonStyle={{ color: 'white', background: 'rgb(223,133,69)', fontSize: '14px' }}
        buttonText='Принимаю'
        expires={365}
      >
        Этот сайт использует куки. Мы не собираем никаких ваших личных данных. Куки требуются исключительно для нормальной работы сайта.</CookieConsent>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/gallery' element={<Gallery/>}/>
        <Route path='/videos' element={<Videos/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/school8' element={<School8/>}/>
        <Route path='/school1' element={<School1/>}/>
        <Route path='/school9' element={<School9/>}/>
        <Route path='/remember' element={<Remember/>}/>
        <Route path='/we' element={<We/>}/>
        <Route path='/poselok' element={<Poselok/>}/>
        <Route path='/parents' element={<Parents/>}/>
        <Route path='/meetings' element={<Meetings/>}/>
        <Route path='/kids' element={<Kids/>}/>
        <Route path='/geology' element={<Geology/>}/>
        <Route path='/kayrakkum' element={<Kayrakkum/>}/>
        <Route path='/kayrakkumer' element={<Kayrakkumer/>}/>
        <Route path='/thanks' element={<Thanks/>}/>
      </Routes>
    </div>
    </>
  );
}

export default App;
